<template>
  <div class="layouts">
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>
<style lang="less">
.header {
  padding: 0 20px;
  height: 50px;
  border-bottom: 1px solid rgb(232, 234, 236);
  margin-bottom: 30px;
  .templateName {
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.groupName {
  position: relative;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px;
}

.groupName::before {
  position: absolute;
  left: 0;
  content: '';
  padding-left: 3px;
  width: 1px;
  top: 4px;
  height: 16px;
  background: #5fc5ce;
  font-size: 12px;
}

.gary-text {
  color: #999;
}

:deep(.ivu-steps) {
  &-tail {
    display: none !important;
  }
}
</style>
<script>
import { mapMutations } from 'vuex';
import app_config from '@/commons/app_config';
export default {
  data() {
    return {
      data: {}
    };
  },
  mounted() {
    this.init_data();
  },
  methods: {
    ...mapMutations({
      set_form: 'set_form'
    }),
    async init_data() {
      if (!this.$route.params.registrationTemplateId) return;
      try {
        const res = await this.$http(
          'GET',
          `${app_config.mainApiEndpoint}/rest/api/v1/registration/form/${this.$route.params.teamId}/${this.$route.params.registrationTemplateId}`,
          {},
          true
        );
        this.data = res.data;
        document.title = res.data.title;
        this.set_form(res.data);
      } catch (e) {
        this.$Message.error({
          content: e.data.message,
          duration: 8
        });
      }
    }
  }
};
</script>
